import BezierEasing from 'bezier-easing';

import gsap from 'gsap';

import Component from '../base/component';
import { qsa, NodeList, toggleClass } from '../base/dom-utils';

const slideEase = new BezierEasing(0.61, 0.01, 0.08, 0.99);

class Slider extends Component {

    constructor(el, opts) {
        super(el, opts);

        this.$els.slideItems = new NodeList(this.options.item, this.$el);

        // little reset
        this.$els.slideItems.els.forEach((item) => {

            gsap.set(item, {
                xPercent: 100
            });

        });
    }

    beforeInit() {

        this.delegate('click', this.options.next, (e) => {
            e.preventDefault();

            if (!this.getState('isAnimating')) {

                this.setState('isAnimating', true);

                const numOfItems = this.$els.slideItems.els.length - 1;

                const currentSlide = this.getState('currentSlide');

                console.log(numOfItems, currentSlide);

                const newSlide = numOfItems === currentSlide ? 0 : currentSlide + 1;

                this.setState('currentSlide', newSlide);

            }

        });

        this.delegate('click', this.options.prev, (e) => {
            e.preventDefault();

            if (!this.getState('isAnimating')) {

                this.setState('isAnimating', true);

                const numOfItems = this.$els.slideItems.els.length - 1;

                const currentSlide = this.getState('currentSlide');

                const newSlide = currentSlide === 0 ? numOfItems : currentSlide - 1;

                this.setState('currentSlide', newSlide);

            }

        });

        this.on('change:currentSlide', (newItem, oldItem) => {

            const newSlide = this.$els.slideItems.eq(newItem);
            const oldSlide = this.$els.slideItems.eq(oldItem);

            const factor = newItem - oldItem > 0 ? 1 : -1;

            const tl = new TimelineMax();

            if (newSlide) {

                tl.set(newSlide, {
                    xPercent: 100 * factor
                });

                tl.to(newSlide, 0.7, {
                    xPercent: 0,
                    onStart: () => toggleClass(newSlide, this.options.changing, true),
                    onComplete: () => {
                        toggleClass(newSlide, this.options.changing, false);
                        toggleClass(newSlide, this.options.active, true);

                        if (oldSlide) {
                            toggleClass(oldSlide, this.options.active, false);
                        }

                        this.setState('isAnimating', false);
                    },
                    ease: new Ease(slideEase)
                });

                if (oldSlide) {
                    tl.to(oldSlide, 0.71, {
                        xPercent: -100 * factor,
                        ease: new Ease(slideEase)
                    }, '-=0.7')
                }
            }

        });

    }

    getInitialState() {
        return {
            currentSlide: 0,
            isAnimating: false
        };
    }

    getDefaultOptions() {
        return {
            item: '.c-slide__item',
            control: '.c-slide__pag',
            changing: 'is-changing',
            active: 'is-active',
            prev: '.c-slide__prev',
            next: '.c-slide__next'
        }
    }
}

export default Slider;


/** WEBPACK FOOTER **
 ** ./components/slider.js
 **/